import React from 'react';
import { Link, NavigateFunction } from 'react-router-dom';
import { flowRight as compose } from 'lodash';

import s from './StartSlide.module.scss';
import { ROUTE_PREFIX } from '../../../constants/router';
import withAuthentication from '../../Auth/AuthenticationWrapper';
import withInterestTestResults, {
  itestResultsType,
} from '../../HomeScreen/DataWrappers/InterestTestResultsWrapper';
import getAssetLink from '../../../util/getAssetLink';
import { withRouter } from '../../../util/withRouter';
import AnimatedLogo from './AnimatedLogo';
import { checkIfTestResultsAreInvalid } from '../../HomeScreen/DataWrappers/TestCompletionRequiredWrapper';

interface StartSlideProps {
  userItestResults?: itestResultsType;
  location: Location;
  navigate: NavigateFunction;
  refetchItestResults: () => Promise<void>;
}

class StartSlide extends React.Component<StartSlideProps> {
  // eslint-disable-next-line react/state-in-constructor
  state: any;

  static defaultProps = {
    userItestResults: undefined,
  };

  render() {
    const { userItestResults, location } = this.props;

    const isPilot = location.pathname.includes('normalization');
    const isVerification = location.pathname.includes('verification');

    const testResultsInvalid = checkIfTestResultsAreInvalid(userItestResults);

    let startUrl: string;
    if (isPilot) {
      startUrl = `${ROUTE_PREFIX}/normalization/identification`;
    } else if (isVerification) {
      startUrl = `${ROUTE_PREFIX}/verification/infographic`;
    } else {
      startUrl = `${ROUTE_PREFIX}/mode-select/interests-test`;
    }

    const checkImg = <img src={getAssetLink('startpage/check.png')} alt="" />;
    const learnMoreImg = (
      <img src={getAssetLink('startpage/learn_more.png')} alt="" />
    );

    return (
      <div className={s.startSlideContainer}>
        <div className={s.startCircleContainer}>
          <div className={s.logoContaner}>
            <AnimatedLogo />
          </div>
          <h1>
            Jopsy.
            <br />
            Entdecke deine Interessen.
            <br />
            Einfach mit Bildern.
          </h1>
          {testResultsInvalid && (
            <button
              className="wideButton"
              type="button"
              onClick={async () => {
                await this.props.refetchItestResults();
                this.props.navigate(startUrl);
              }}
              aria-label="Starte den Interessenstest"
            >
              <span>START</span>
            </button>
          )}
          {!testResultsInvalid && (
            <button
              className="wideButton"
              type="button"
              onClick={async () => {
                this.props.navigate(`${ROUTE_PREFIX}/home`);
              }}
              aria-label="Zu meinen Ergebnissen"
            >
              <span>MEINE ERGEBNISSE</span>
            </button>
          )}
        </div>
        <div className={s.textBoxesContainer}>
          <div className={s.textBoxLeft}>
            <div className={s.textBoxHeader}>
              <img src={getAssetLink('startpage/why_jopsy.png')} alt="" />
              <h2>WARUM JOPSY?</h2>
            </div>
            <div className={s.textBoxContent}>
              <p>
                Mit Jopsy entdeckst du in nur wenigen Minuten deine persönlichen
                Interessen inklusive Berufsvorschläge.
              </p>
              <ul>
                <li>
                  {checkImg}
                  <span>wissenschaftlich belegt</span>
                </li>
                <li>
                  {checkImg}
                  <span>anonym</span>
                </li>
                <li>
                  {checkImg}
                  <span>individuell</span>
                </li>
              </ul>
              <div className={s.learnMoreButtonContainer}>
                <Link
                  className="wideButton"
                  to={`${ROUTE_PREFIX}/warum-jopsy`}
                  aria-label='Zur "Warum Jopsy?" Unterseite'
                >
                  <span>ERFAHRE MEHR</span>
                  {learnMoreImg}
                </Link>
              </div>
            </div>
          </div>
          <div className={s.textBoxRight}>
            <div className={s.textBoxHeader}>
              <img src={getAssetLink('startpage/find_jobs.png')} alt="" />
              <h2>BERUFE ENTDECKEN</h2>
            </div>
            <div className={s.textBoxContent}>
              <p>
                Du weißt schon, wo es hingehen soll?
                <br />
                Du willst dich inspirieren lassen?
                <br />
                Schau in die Berufsliste!
              </p>
              <ul className={s.textBoxList}>
                <li>
                  {checkImg}
                  <span>aktuell</span>
                </li>
                <li>
                  {checkImg}
                  <span>über 700 Berufe</span>
                </li>
                <li>
                  {checkImg}
                  <span>kompakt erklärt</span>
                </li>
              </ul>
              <div className={s.learnMoreButtonContainer}>
                <Link
                  className="wideButton"
                  to={`${ROUTE_PREFIX}/berufe-entdecken`}
                  aria-label='Zur "Facts" Unterseite'
                >
                  <span>ERFAHRE MEHR</span>
                  {learnMoreImg}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  withAuthentication,
  withInterestTestResults,
  withRouter,
)(StartSlide);
